const serializeObject = data =>
    Object.entries(data)
        .map(([key, value]) =>
            value || value === 0 ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : null
        )
        .filter(Boolean)
        .join('&')
        .replace(/%20/g, '+');

export default serializeObject;
